import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="vanilla-nested"
export default class extends Controller {
  static targets = ["noneText", "submitButton"];
  static values = { limit: Number };

  declare noneTextTarget: HTMLElement; // Texte "Aucun élément"
  declare hasNoneTextTarget: boolean;
  declare submitButtonTarget: HTMLElement;
  declare hasSubmitButtonTarget: boolean;
  declare limitValue: number;
  declare hasLimitValue: boolean;

  connect() {
    document.addEventListener("vanilla-nested:fields-added", (e) => {
      let nestedElements = document.getElementsByClassName("added-by-vanilla-nested");
      if (nestedElements && nestedElements.length > 0) {
        if (this.hasNoneTextTarget) {
          this.noneTextTarget.classList.add("hidden");
        }
        if (this.hasSubmitButtonTarget) {
          this.submitButtonTarget.classList.remove("hidden");
        }
      } else {
        if (this.hasNoneTextTarget) {
          this.noneTextTarget.classList.remove("hidden");
        }
      }
    });
  }
}
